'use client';

import { useDispatch, useSelector } from 'react-redux';

import useAmplitudeContext from '@/hooks/useAmplitudeContext';
import {
    filterDeselect,
    filterSelect,
    filtersReset,
    selectFiltersAvailable,
    selectFiltersSelected,
    selectFiltersSelectedCount,
} from '@/store/calendar-filters';
import { FilterItem } from '@/types/filters';
import { amplitudeEvents } from '@/utils/constants';

export const useFilters = () => {
    const { trackAmplitudeEvent } = useAmplitudeContext();
    const dispatch = useDispatch();

    const filtersAvailable = useSelector(selectFiltersAvailable);
    const filtersSelected = useSelector(selectFiltersSelected);
    const filtersSelectedCount = useSelector(selectFiltersSelectedCount);

    const handleAddFilter = (filterItem: FilterItem) => {
        dispatch(filterSelect(filterItem));
        trackAmplitudeEvent(amplitudeEvents.FILTER_SELECT_CLICK, {
            category: filterItem.key,
            value: filterItem.display,
        });
    };
    const handleRemoveFilter = (filterItem: FilterItem) => {
        dispatch(filterDeselect(filterItem));
        trackAmplitudeEvent(amplitudeEvents.FILTER_REMOVE_CLICK, {
            category: filterItem.key,
            value: filterItem.display,
        });
    };
    const handleResetFilters = () => {
        dispatch(filtersReset());
        trackAmplitudeEvent(amplitudeEvents.FILTER_REMOVE_CLICK, { value: 'all' });
    };

    return {
        filtersAvailable: filtersAvailable,
        filtersSelected: filtersSelected,
        filtersSelectedCount: filtersSelectedCount,
        handleAddFilter: handleAddFilter,
        handleRemoveFilter: handleRemoveFilter,
        handleResetFilters: handleResetFilters,
    };
};
